












import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductRecommendationsBlockViewModel } from '@/types/contentServerContract';
import { ProductRecommendationType, ProductTileViewModel, ProductTileViewObject } from '@/types/apiServerContract';
import loggingService from '@/core/logging.service';
import Api from '@/project/http/Api.service';
import CondensedProductList from '@/project/product/condensed/CondensedProductList.vue';
import urlHelperService, { UrlQueryKey } from '@/core/urlHelper.service';

@Component({
    components: { CondensedProductList }
})
export default class ProductRecommendationsBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    })
    private content!: ProductRecommendationsBlockViewModel;

    @Prop({
        required: false,
        type: Boolean,
        default: false
    })
    private isFirstBlock!: boolean;

    get appendToPreviousBlock() {
        return this.content.appendToPreviousBlock && !this.isFirstBlock;
    }

    @Prop({
        required: false,
        type: String
    })
    private productId!: string | undefined;

    private result: ProductTileViewModel | null = null;

    private get products(): ProductTileViewObject[] {
        return this.result ? this.result.products : [];
    }

    private get listViewPageSize(): undefined | number {
        return this.content.useListView ? 4 : undefined;
    }

    private async getProductData() {
        try {
            this.result = await Api.recommendations.recommend({
                categoryIdFilterPositiveList: this.content.categoryIdFilterPositiveList,
                categoryIdFilterNegativeList: this.content.categoryIdFilterNegativeList,
                displayedAtLocation: this.content.displayLocation,
                intervalDays: this.content.interval,
                popularityType: this.content.popularity,
                categoryId: this.content.categoryId,
                productId: this.productId || urlHelperService.getQueryParam(UrlQueryKey.wid),
                productCount: this.content.productCount,
                recommendationType: this.content.type,
                allowFillIfNecessary: this.content.allowFillIfNecessary,
                brandId: this.content.brandId,
                hasImages: this.content.hasImages,
                stockFilter: this.content.stockFilter,
                showFeedProducts: this.content.showFeedProducts
            });
        } catch (e) {
            loggingService.error(e);
        }
    }

    private get headline(): string | undefined {
        return this.content?.headline;
    }

    private get trackingListName():string {
        const key = Object.keys(ProductRecommendationType).filter((v) => isNaN(Number(v))).find(k => ProductRecommendationType[k] === this.content.type) || 'recommendation';
        // format: recommendation/relation - page type - recommendation type
        return `recommendations-${this.$route.name}-${key}`;
    }

    private created() {
        this.getProductData();
    }
}
